<spike-base-page [breadcrumbItems]="breadcrumb" [title]="'Progressione: ' + year()">
  
  <div actions class="flex gap-2">
    <p-button (click)="view.set(view() === 'table' ? 'chart' : 'table')" 
              [icon]="view() === 'table' ? 'pi pi-chart-bar' : 'pi pi-table'" 
              [label]="view() === 'table' ? 'Grafici' : 'Tabelle'" 
              severity="secondary" class="mr-4">
    </p-button>
    <p-button (click)="pagePrev()" [label]="(year()-1)+''" icon="pi pi-arrow-left"></p-button>
    <p-button (click)="pageNext()" [label]="(year()+1)+''" icon="pi pi-arrow-right" iconPos="right"></p-button>
  </div>

  <div class="spike-table-card">
    
    @if (view() === 'table') {
      <spike-trade-monthly-recap-table 
        [headerName]="''" [recapList]="[]" [showHeader]="true" [transformType]="'currency'">
      </spike-trade-monthly-recap-table>

      <spike-trade-monthly-recap-table 
        [headerName]="'Liquidità'" 
        [recapList]="walletProgressListLiq()" 
        [addRowTotal]="true" 
        [transformType]="'currency'"
        [enableDetail]="true"
        (onDetail)="openDetail($event)"> 
      </spike-trade-monthly-recap-table>

      <spike-trade-monthly-recap-table
        [headerName]="'Investimenti'"
        [recapList]="walletProgressListInv()"
        [addRowTotal]="true"
        [transformType]="'currency'"
        [enableDetail]="true"
        (onDetail)="openDetail($event)">
      </spike-trade-monthly-recap-table>

      <spike-trade-monthly-recap-table 
        [headerName]="''" 
        [recapList]="yearProgressTotalList()" 
        [transformType]="'currency'"> 
      </spike-trade-monthly-recap-table>

    } @else {
      <spike-wallet-bar-chart 
      [walletProgressListLiq]="walletProgressListLiq()"
      [walletProgressListInv]="walletProgressListInv()"/>

    }

  </div>
</spike-base-page>